var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGestodaCandidatura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gest\xC3\xA3o da Candidatura"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.4492 6.28713C27.4296 6.28713 26.5799 5.43752 26.5799 4.418C26.5799 3.39847 27.4296 2.54887 28.4492 2.54887C29.4688 2.54887 30.3184 3.39847 30.3184 4.418C30.3184 5.43752 29.4688 6.28713 28.4492 6.28713ZM28.4492 6.10352e-05C27.0048 6.10352e-05 25.6454 0.722254 24.8381 1.9117C24.031 3.10114 23.861 4.63043 24.3708 5.9898L26.3675 10.3652L28.0668 13.9761C28.1944 14.1885 28.4492 14.2734 28.6191 14.146C28.7042 14.1035 28.7465 14.0611 28.7891 13.9761L30.4884 10.3652L32.4851 5.9898C32.9948 4.63043 32.8249 3.10114 32.0178 1.9117C31.2531 0.722254 29.8937 6.10352e-05 28.4492 6.10352e-05Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.78303 23.2792C5.50848 23.2792 4.44638 22.2172 4.44638 20.9428C4.44638 19.6684 5.50848 18.6064 6.78303 18.6064C8.05746 18.6064 9.11957 19.6684 9.11957 20.9428C9.11957 22.2172 8.05746 23.2792 6.78303 23.2792ZM6.78303 15.5053C4.99868 15.5053 3.29937 16.3974 2.27977 17.8842C1.26018 19.371 1.04774 21.2826 1.72746 22.9393L4.19154 28.3768L6.31563 32.8372C6.44317 33.0922 6.78303 33.1771 7.03787 33.0496C7.1229 33.0071 7.2078 32.9222 7.25031 32.8372L9.3744 28.3768L11.8385 22.9393C12.4757 21.2826 12.2632 19.371 11.2862 17.8842C10.2666 16.3974 8.56726 15.5053 6.78303 15.5053Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7306 33.1346H11.626C11.1162 33.1346 10.6489 33.1346 10.1816 33.1346V30.5858C10.6064 30.5858 11.1162 30.5858 11.626 30.5858H12.7306V33.1346Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.4724 33.1347V30.5859C15.4071 30.5859 16.2142 30.5859 16.979 30.5435L17.0639 33.0923C16.2568 33.1347 15.4071 33.1347 14.4724 33.1347Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.7632 33.0072L18.6357 30.4584C19.5279 30.4159 20.3776 30.3735 21.0997 30.2885L21.3547 32.8373C20.5899 32.9223 19.6978 32.9647 18.7632 33.0072Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.1388 32.6249L22.7566 30.1186C23.5637 29.9911 24.3284 29.8637 25.0931 29.6513L25.7729 32.1151C24.8807 32.3275 24.031 32.4974 23.1388 32.6249Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.5572 31.4779L26.5376 29.1415C27.0899 28.9716 27.5572 28.5893 27.8971 28.122L30.1487 29.354C29.5115 30.331 28.6193 31.0532 27.5572 31.4779Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.9395 27.2724C27.8546 26.7201 27.5997 26.1679 27.2173 25.7856L29.0016 24.0014C29.8088 24.8085 30.3186 25.828 30.446 26.9751L27.9395 27.2724Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.1552 25.0209C25.4755 24.681 24.7532 24.3837 24.031 24.1713L24.7532 21.7499C25.6454 22.0048 26.5375 22.3447 27.3447 22.7694L26.1552 25.0209Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.4167 23.7465L21.737 23.5765C21.1422 23.4066 20.505 23.2791 19.9102 23.1092L20.5899 20.6454C21.1422 20.8153 21.737 20.9427 22.3317 21.1126L23.0114 21.2826L22.4167 23.7465Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.1684 22.5146C17.1488 22.1323 16.2142 21.4951 15.5344 20.6455L17.6161 19.2011C17.9985 19.6685 18.5507 20.0083 19.103 20.1782L18.1684 22.5146Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.4462 18.3515L14.8972 18.1816C14.9821 16.9498 15.6618 15.8452 16.639 15.123L18.2108 17.1197C17.4462 17.7569 17.4462 18.2241 17.4462 18.3515Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M19.4002 16.4825L18.3806 14.1461C19.2303 13.7637 20.1224 13.4664 21.0146 13.254L21.6093 15.7179C20.8447 15.9303 20.1224 16.1851 19.4002 16.4825Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M23.1814 15.4205L22.7566 12.9141C23.8611 12.7442 24.7958 12.6168 25.3905 12.5743L25.6029 15.1231C25.178 15.1656 24.2435 15.2506 23.1814 15.4205Z",
    fill: "#FFC000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestodaCandidatura);
export default __webpack_public_path__ + "static/media/Gestão da Candidatura.0c73631b51ab30bfb5af54472a6eb3a3.svg";
export { ForwardRef as ReactComponent };